/**
 * Created by nghinv on Sun Jun 06 2021
 * Copyright (c) 2021 nghinv@lumi.biz
 */

import * as Colors from './ColorsPalette';

/**
 * Convert hex color to rgba color with opacity
 * @param hexCode hex color
 * @param opacity from 0 to 100
 * @returns rgba color
 */
function hexToRgba(hexCode: string, opacity: number): string {
  try {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity / 100})`;
  } catch (error) {
    return hexCode;
  }
}

export { Colors, hexToRgba };
